/** @format */

import { useQuery } from "@tanstack/react-query";
import service from "../utils/service"

const useGetUserStatuses = () => useQuery({
  queryKey: ["getUserStatuses"],
  queryFn: () => service.getUserStatuses(),
  select: (data) => data.data,
  cacheTime: Infinity,
  staleTime: Infinity
})

export default useGetUserStatuses;